import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { NgCakeItEasyUtilsModule } from '@cakeiteasy/web-utils';

import { RETURN_METHODS } from '../../../return-packaging/models/return-packaging.constants';
import { IReturnPackagingLine } from '../../../return-packaging/models/i-return-packaging-details';

/**The return summary in the cart. It sits beside cart-delivery rather than among the cart lines
 * because the RETURN_PACKAGING order line carries no product and is held off `cart.lines`.*/
@Component({
  standalone: true,
  selector: 'cart-return-packaging',
  imports: [TranslateModule, NgCakeItEasyUtilsModule],
  templateUrl: './cart-return-packaging.component.html',
  styleUrls: ['./cart-return-packaging.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartReturnPackagingComponent {
  readonly returnPackaging = input.required<IReturnPackagingLine>();
  readonly currency = input<string>('');
  readonly showEdit = input<boolean>(true);

  readonly onEdit = output<void>();

  readonly details = computed(() => this.returnPackaging().returnPackaging);
  readonly isSelfReturn = computed(() => this.details().returnMethod === RETURN_METHODS.SELF);

  /**Self-returns are free, and the server prices the line, so an absent price means no charge to
   * show rather than a price still loading.*/
  readonly price = computed(() => this.returnPackaging().price || 0);

  readonly titleKey = computed(() => this.isSelfReturn()
    ? 'cart.returnPackaging.self'
    : 'cart.returnPackaging.courier');
}
